import store from '../store/index'
/**
 * 调用原生app方法(主动调起)
 */

// 调用IOS原生方法
const _native = (name, body) => {
  if (window.webkit && window.webkit.messageHandlers) {
    window.webkit.messageHandlers[name].postMessage(body)
  }
}

// 获取token
// IOS
export const getIOSToken = () => {
  _native('Token', 'Token')
}

/**
 * 暴露给app调用的js方法(将方法加载在window._mz_对象下面，被动调起)
 */

// 获取token
// IOS
const getToken = function (token) {
  store.dispatch('setToken', token)
}

// 加载需要暴露的方法
export const loadJsFunction = function () {
  window._mz_ = {
    getToken: getToken // 获取token
  }
}
